import { render, staticRenderFns } from "./BlockAddress.vue?vue&type=template&id=4696e436&"
import script from "./BlockAddress.vue?vue&type=script&lang=js&"
export * from "./BlockAddress.vue?vue&type=script&lang=js&"
import style0 from "./BlockAddress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports